import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";


export default function CheckoutForm() {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Your payment was successful!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });
  }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/orderconfirmed`,
      },
    });

    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: {
      type: 'tabs',
      defaultCollapsed: false,
      radios: true,
      spacedAccordionItems: false
    }
  };

  return (
    <form
      id="payment-form"
      style={{
        margin: "0 auto",
        borderRadius: "15px",
        color: "#000",
      }}
      onSubmit={handleSubmit}
    >
      <PaymentElement id="payment-element" options={paymentElementOptions} />
      <button
        disabled={isLoading || !stripe || !elements}
        id="submit"
        style={{
          borderRadius: "20px",
          border: "0",
          padding: "14px 16px",
          fontSize: "16px",
          fontWeight: "600",
          color: "#fff",
          backgroundColor: "var(--primary-color, #dc3545)",
          cursor: "pointer",
          display: "block",
          transition: "all 0.2s ease",
          width: "100%",
          marginTop: "12px",
        }}
      >
        <span id="button-text">
          {isLoading ? (
            <p>Processing Payment... <br /> DO NOT LEAVE THIS PAGE!</p>
          ) : (
            "Place Order"
          )}
        </span>
      </button>
      {message && (
        <div
          id="payment-message"
          style={{
            color: "red",
            fontWeight: "bold",
            paddingTop: "12px",
            textAlign: "center",
            fontSize: '14px'
          }}
        >
          {message}
        </div>
      )}
    </form>
  );
}
